import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTES } from 'src/app/shared/config';
import { RunService } from 'src/app/shared/services';

@Component({
  selector: 'app-center',
  templateUrl: './center.component.html',
  styleUrls: ['./center.component.styl']
})
export class RedCenterComponent implements OnInit {
  deviceMode = null;

  data: {label: string, subs: any[]}[] = [];

  constructor(
    private router: Router,
    private runService: RunService
  ) { }

  ngOnInit() {
    this.data = ROUTES[1].data[1].subs;
  }

  toTuoYu(url: string) {
    this.runService.reBackUrl = '/red/center';
    this.router.navigateByUrl(url);
  }
}
